var map = {
	"./arrow_left.svg": 303,
	"./arrow_right.svg": 304,
	"./art.svg": 305,
	"./box.svg": 306,
	"./brush.svg": 307,
	"./camera.svg": 308,
	"./cardboard.svg": 309,
	"./certificate.svg": 310,
	"./check_mark.svg": 311,
	"./code.svg": 312,
	"./compass.svg": 313,
	"./cross.svg": 314,
	"./cursor.svg": 315,
	"./devices.svg": 316,
	"./diamond.svg": 317,
	"./diamond_new.svg": 318,
	"./experience.svg": 319,
	"./facebook.svg": 320,
	"./gear.svg": 321,
	"./gift.svg": 322,
	"./info.svg": 323,
	"./instagram.svg": 324,
	"./lang.svg": 325,
	"./location.svg": 326,
	"./logo.svg": 327,
	"./map.svg": 328,
	"./media.svg": 329,
	"./metro_line.svg": 330,
	"./metro_logo.svg": 331,
	"./metro_mcc.svg": 332,
	"./more.svg": 333,
	"./navigation.svg": 334,
	"./pano.svg": 335,
	"./play.svg": 336,
	"./price.svg": 337,
	"./streetview.svg": 338,
	"./twitter.svg": 339,
	"./video.svg": 340,
	"./vk.svg": 341,
	"./walk.svg": 342,
	"./yandexmap.svg": 343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 302;